import styled from "styled-components";
import {Layout} from "antd";

export const StyledLayout = styled(Layout)`
  &.theme-light {
    .ant-layout-sider {
      .ant-menu-item{
        .anticon {
          margin-left: 0;
        }
        
        &.ant-menu-item-selected{
          path{
            stroke: #6b64ff;
          }
        }
      }
      .sider-button {
        &:after {
          background: #fff;
        }
      }
    }
  }

  &.theme-dark {
    .ant-layout-sider {
      .ant-menu-item{
        .anticon {
          margin-left: 0;
        }
        
        &.ant-menu-item-selected{
          path{
            stroke: #6b64ff;
          }
        }
      }
      .sider-button {
        &:after {
          background: #1E1E1E;
        }
      }
    }
  }
`